import React, { createContext, use, useCallback, useState } from 'react'

interface MapContextType {
  map: google.maps.Map | null
  setMap: (map: google.maps.Map | null) => void
  currentCenter: google.maps.LatLngLiteral
  setCurrentCenter: (center: google.maps.LatLngLiteral) => void
  updateMapCenter: (center: google.maps.LatLngLiteral) => void
}

const MapContext = createContext<MapContextType | undefined>(undefined)

export const MapProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [map, setMap] = useState<google.maps.Map | null>(null)
  const [currentCenter, setCurrentCenter] = useState<google.maps.LatLngLiteral>(
    {
      lat: 48.856_614,
      lng: 2.352_221_9,
    }
  )

  const updateMapCenter = useCallback(
    (center: google.maps.LatLngLiteral) => {
      if (map) {
        map.setCenter(center)
        setCurrentCenter(center)
      }
    },
    [map]
  )

  return (
    <MapContext.Provider
      value={{
        map,
        setMap,
        currentCenter,
        setCurrentCenter,
        updateMapCenter,
      }}
    >
      {children}
    </MapContext.Provider>
  )
}

export const useMap = () => {
  const context = use(MapContext)
  if (context === undefined) {
    throw new Error('useMap must be used within a MapProvider')
  }
  return context
}
